"use strict";

var isValue = require("./is-value");

module.exports = function (value) {
	if (!isValue(value)) throw new TypeError("Cannot use null or undefined");
	return value;
};



// WEBPACK FOOTER //
// ./node_modules/event-emitter/node_modules/es5-ext/object/valid-value.js